import * as moment from 'moment'
import { TimeRangeMoment } from './time-range-moment';
export class AbsoluteDateRangeIntervals {
    intervals: Array<TimeRangeMoment> = new Array();
    constructor(offset: any) {
        if (offset == 'Client default') {
            this.intervals.push(new TimeRangeMoment(moment().startOf('day'), moment().endOf('day'), 'Today'));
            this.intervals.push(new TimeRangeMoment(moment().startOf('day').subtract(1, 'day'), moment().endOf('day').subtract(1, 'day'), 'Yesterday'));
            this.intervals.push(new TimeRangeMoment(moment().startOf('week').isoWeekday(1).add(1, 'week'), moment().endOf('week').isoWeekday(1).subtract(1, 'day').add(1, 'week'), 'This week'));
            this.intervals.push(new TimeRangeMoment(moment().startOf('month'), moment().endOf('month'), 'This month'));
            this.intervals.push(new TimeRangeMoment(moment().subtract(20, 'year'), moment().add(20, 'year'), 'All time'));
        } else {
            this.intervals.push(new TimeRangeMoment(moment().utcOffset(parseInt(offset)).startOf('day'), moment().utcOffset(parseInt(offset)).endOf('day'), 'Today'));
            this.intervals.push(new TimeRangeMoment(moment().utcOffset(parseInt(offset)).startOf('day').subtract(1, 'day'), moment().utcOffset(parseInt(offset)).endOf('day').subtract(1, 'day'), 'Yesterday'));
            this.intervals.push(new TimeRangeMoment(moment().utcOffset(parseInt(offset)).startOf('week').isoWeekday(1).add(1, 'week'), moment().utcOffset(parseInt(offset)).endOf('week').isoWeekday(1).subtract(1, 'day').add(1, 'week'), 'This week'));
            this.intervals.push(new TimeRangeMoment(moment().utcOffset(parseInt(offset)).startOf('month'), moment().utcOffset(parseInt(offset)).endOf('month'), 'This month'));
            this.intervals.push(new TimeRangeMoment(moment().subtract(5, 'year'), moment().add(5, 'year'), 'All time'));
        }




    }
}